export class AppInfo
{
  public static Version: string;
  public static Platform: string;
  public static UUID: string;
  public static AppSubVersion: string = "";//78
  public static Environment: string;
}